<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('tenantModule', [
      'modules',
      'viewedShopModules'
    ])
  },
  methods: {
    $hasModule (slug) {
      return this.modules.indexOf(slug) !== -1
    },

    $hasAnyModule(slugs){
      if(!slugs || slugs.length === 0){
        return true
      }
      for(let slug of slugs){
        if(this.modules.indexOf(slug) !== -1){
          return true
        }
      }
      return false
    },

    // Comme $hasModule, mais pour la boutique en cours de CONSULTATION
    // (Détail boutique, ...) plutôt que la boutique active de vente — voir
    // store/modules/tenantModule.
    $hasShopModule (slug) {
      return this.viewedShopModules.indexOf(slug) !== -1
    }
  }
}
</script>
